<img class="lazyload" data-src="{{data ? data : '../../../assets/images/avatar.png'}}" alt="suntour-reisen.de" [class.avatar]="small()" [class.big-avatar]="!small()" style="height: 100%;width: auto;">
